import { UpdateTypes } from '../../shared/enums/updateTypes';
import { FilterViewModel } from '../../shared/models/filter/filterViewModel';

export class ModifiableEntityViewModel {
  id: number;
  title: string;
  filters: FilterViewModel[];
  permissionFilters: FilterViewModel[];
  orderValue: number;
  createdById: number;
  updated: string;
  isPinned: boolean;
  archived: boolean;
  isShared: boolean;
  isSelected?: boolean
  generalCommentUpdate: UpdateTypes = undefined;
  accountId: number;
}
